<template>
  <div>
    <AuctionBids />
    <AgentCardDialog />

    <v-dialog :lazy="true" v-model="cancelDialogVisible.visible" max-width="640px">
      <div style="position: relative; background-color: #fff; text-align: center;" v-if="cancelDialogVisible.auction">
        <v-icon style="cursor: pointer; position: absolute; right: 0; top: 0; padding: 0.5rem;" @click.stop="cancelDialogVisible.visible = false">close</v-icon>
        <div style="padding: 2em;">
          <div style="text-align: center; padding: 1rem 1.5rem; font-size: 1.4rem; font-weight: 400;">Cancel Auction?</div>
          <p>
            You are about the cancel the auction of {{ cancelDialogVisible.auction.address }} (ID {{ cancelDialogVisible.auction.id }}).
          </p>
          <p>
            This means that the auction will be no longer active, even if the bidding has been started.
            All participants will be notified via email about the cancellation.
            This action cannot be undone. Are you sure?
          </p>
          <p><textarea rows="5" placeholder="Enter a reason for the cancellation" v-model="cancelDialogVisible.reason"></textarea></p>
          <p>
            <button class="btn-neutral wider" @click.stop="cancelDialogVisible.visible = false">Back</button>
            <button class="btn-danger" @click.stop="cancelAuction" :disabled="cancelDialogVisible.reason.length === 0">Confirm Auction Cancellation</button>
          </p>
        </div>
      </div>
    </v-dialog>

    <div class="container">
      <!-- TODO what about "all listings" page? this.$PfxBackendApi.getTenantAuctions() -->

      <div class="clearfix" style="margin-bottom: 3rem;" v-if="isDashboardEmpty() && !showAssistantSection() && !showListingAgentSection()">
        <h3>Activities on PFX</h3>
        <h2>Dashboard</h2>
        <div class="no-content-container">
          <div class="no-content-text">
            <div>No auction activities.</div>
            <p>Check out the properties available on PFX!</p>
          </div>
          <router-link to="/listings"><button>Browse Auctions</button></router-link>
        </div>
      </div>

      <div v-if="showAssistantSection()">
        <div class="clearfix">
          <div style="float:right">
            <TutorialToggle name="DashboardTutorial" :disabled="tooltipsDisabled" />
          </div>
        </div>
        <div class="clearfix">
          <div>
            <img style="height: 38px; float:left; margin-right: 12px;" :src="$store.state.tenant.data.logoUrl" />
            <h3>Auctions on {{ $store.state.tenant.data.name }}</h3>
            <WithTutorial
              name="DashboardTutorial" :order="1"
              heading="Welcome to PFX!"
              text="This is the tenant Dashboard. You can access all the auctions open for this tenant."
              placement="right">
            </WithTutorial>
          </div>
        </div>
        <div class="clearfix">
          <div>
            <h2>Office Assistant</h2>
          </div>
        </div>
        <div>
          
          <div v-if="auctionsForAssistant.length > 0">
            <fieldset class="col-14">
              <v-text-field v-model="officeAssistantSearch" label="Search" single-line hide-details ></v-text-field>
            </fieldset>
          </div>

          <v-data-table class="dashboard" :search="officeAssistantSearch" :headers="headersForAssistant" :pagination.sync="paginationForAssistant" :items="auctionsForAssistant" must-sort hide-actions item-key="id">
            <template slot="items" slot-scope="props">
              <tr style="cursor:pointer;">
                <td>
                  <div class="clearfix data-table-property-info">
                    <div class="photo-container" :style="'background-image: url(' + auctionPhoto(props.item) + ');'">
                    </div>
                  </div>
                </td>
                <td>
                  <div class="data-container">
                    <div class="address">{{ props.item.address }}</div>
                    <div>
                      <a @click.stop="openAgentCardDialog({ agentProfile: props.item.listingAgentProfile, tenantSubdomain: $store.state.tenant.subdomain })">
                        {{ props.item.listingAgentProfile.firstName }} {{ props.item.listingAgentProfile.lastName }}
                      </a>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="sub">Start</div>
                  <div>{{ props.item.startDate | prettyDateTimeShort(props.item.metadata.timezone) }}</div>
                </td>
                <td>
                  <div class="sub">End</div>
                  <div>{{ props.item.endDate | prettyDateTimeShort(props.item.metadata.timezone) }}</div>
                </td>
                <td>
                  <template v-if="props.item.status === auctionStatuses.OPEN.value || props.item.status === auctionStatuses.FREEZE.value">
                    <div class="sub">{{ props.item.startDate | delta | countdownTimer }}</div>
                  </template>
                  <template v-else-if="props.item.status === auctionStatuses.AUCTION.value">
                    <div class="sub">{{ props.item.endDate | delta | countdownTimer }}</div>
                  </template>
                  <AuctionStatusIndicator :auction="props.item" />
                  <!-- <template v-if="props.item.injected.winner.alias">
                    <div class="winner-pill">{{ props.item.injected.winner.alias }}</div>
                  </template> -->
                </td>

                <td class="actions">
                  <template v-if="!isEditDisabled(props.item)">
                    <router-link :to="'/dashboard/create/' + props.item.id"><v-icon size="x-large" color="grey lighten-1">edit</v-icon></router-link>
                  </template>
                  <!-- <template v-if="!isEditDisabled(props.item)">
                    <router-link :to="'/dashboard/delegate/' + props.item.id"><v-icon size="x-large" color="grey lighten-1">person_add</v-icon></router-link>
                  </template>
                  <template v-if="!isDeleteDisabled(props.item)">
                    <a @click.stop="deleteAuctionDialog(props.item)"><v-icon size="x-large" color="grey lighten-1">delete</v-icon></a>
                  </template>
                  <template v-if="!isCancelDisabled(props.item)">
                    <a @click.stop="cancelAuctionDialog(props.item)"><v-icon size="x-large" color="grey lighten-1">block</v-icon></a>
                  </template> -->
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
        <WithTutorial
          name="DashboardTutorial" :order="2"
          heading="Welcome to PFX!"
          text="This is where you will find information about all auctions such as the property,
          the period and status or other auction details."
          placement="bottom" block>
          <span></span>
        </WithTutorial>
      </div>

      <div v-if="showListingAgentSection()">
        <div class="clearfix">
          <div style="float:right">
            <TutorialToggle name="DashboardTutorial" :disabled="tooltipsDisabled" />
          </div>
        </div>
        <div class="clearfix">
          <div style="float: right;">
            <WithTutorial
              name="DashboardTutorial" :order="3" last
              heading="Welcome to PFX!"
              text="Get started by creating a New Auction from here!"
              placement="left">
              <router-link to="/dashboard/create"><button>Create New Auction</button></router-link>
            </WithTutorial>
          </div>
          <div>
            <img style="height: 38px; float:left; margin-right: 12px;" :src="$store.state.tenant.data.logoUrl" />
            <h3>Auctions on {{ $store.state.tenant.data.name }}</h3>
            <WithTutorial
              name="DashboardTutorial" :order="1"
              heading="Welcome to PFX!"
              text="This is your Dashboard. You can access the auctions you create, as well as the other auctions where you are assigned as a delegate."
              placement="right">
            </WithTutorial>
          </div>
        </div>
        <div class="clearfix">
          <div>
            <h2>Listing Agent</h2>
          </div>
        </div>

        <div v-if="auctionsForListingAgent.length > 0">
          <fieldset class="col-14">
            <v-text-field v-model="listingAgentSearch" label="Search" single-line hide-details ></v-text-field>
          </fieldset>
        </div>

        <v-data-table class="dashboard" :search="listingAgentSearch" :headers="headersForListingAgent" :pagination.sync="paginationForListingAgent" :items="auctionsForListingAgent" must-sort hide-actions item-key="id">
          <!-- <template slot="no-data">
            <div class="no-content-container">
              <div class="no-content-text">
                <div>No listing agent auction activities.</div>
                <p>Go ahead and create your first auction!</p>
              </div>
              <router-link to="/dashboard/create"><button>Create New Auction</button></router-link>
            </div>
          </template> -->
          <template slot="items" slot-scope="props">
            <tr @click="props.expanded = !props.expanded;loadDataForDelegatedgAgent(props.item.id)" style="cursor:pointer;">
              <td>
                <div class="clearfix data-table-property-info">
                  <div class="photo-container" :style="'background-image: url(' + auctionPhoto(props.item) + ');'">
                  </div>
                  <div class="data-container">
                    <div class="sub">{{ auctionTypeLabel(props.item.metadata.type) }}</div>
                    <div class="address">{{ props.item.address }}</div>
                    <div>
                      <a @click.stop="openAgentCardDialog({ agentProfile: props.item.listingAgentProfile, tenantSubdomain: $store.state.tenant.subdomain })">
                        {{ props.item.listingAgentProfile.firstName }} {{ props.item.listingAgentProfile.lastName }}
                      </a>
                    </div>
                  </div>
                </div>
              </td>

              <td>
                <div style="display: inline-block; margin-right: .5rem;">{{ props.item.participants.applicant + props.item.participants.buyer + props.item.participants.winner + props.item.participants.abandon }}</div>
                <div class="bidders-pill" v-if="props.item.participants.applicant > 0"><router-link :to="'/dashboard/bidders/' + props.item.id">{{ props.item.participants.applicant }} Pending</router-link></div>
              </td>

              <td>
                <template v-if="props.item.status === auctionStatuses.PROCESSING.value || props.item.status === auctionStatuses.IN_ESCROW.value || props.item.status === auctionStatuses.SOLD.value || props.item.status === auctionStatuses.CANCELLED.value || props.item.status === auctionStatuses.CLOSED.value">
                  <div class="sub">Highest Bid</div>
                </template>
                <template v-else>
                  <div class="sub">Current Bid</div>
                </template>
                <div>
                  {{ props.item.currentPrice | prettyMoney }}
                  <span v-if="props.item.injected.bids.length > 0" style="text-decoration: underline; margin-left: .5em;" @click.stop="$store.commit('openBidsDialog', props.item.id)">{{ props.item.injected.bids.length }} Bids</span>
                </div>
              </td>

              <td>
                <div class="sub">Start</div>
                <div>{{ props.item.startDate | prettyDateTimeShort(props.item.metadata.timezone) }}</div>
              </td>

              <td>
                <template v-if="props.item.status === auctionStatuses.OPEN.value || props.item.status === auctionStatuses.FREEZE.value">
                  <div class="sub">{{ props.item.startDate | delta | countdownTimer }}</div>
                </template>
                <template v-else-if="props.item.status === auctionStatuses.AUCTION.value">
                  <div class="sub">{{ props.item.endDate | delta | countdownTimer }}</div>
                </template>
                <AuctionStatusIndicator :auction="props.item" />
                <template v-if="props.item.injected.winner.alias">
                  <div class="winner-pill">{{ props.item.injected.winner.alias }}</div>
                </template>
              </td>

              <td class="actions">
                <template v-if="!isEditDisabled(props.item)">
                  <router-link :to="'/dashboard/create/' + props.item.id"><v-icon size="x-large" color="grey lighten-1">edit</v-icon></router-link>
                </template>
                <template v-if="!isEditDisabled(props.item)">
                  <router-link :to="'/dashboard/delegate/' + props.item.id"><v-icon size="x-large" color="grey lighten-1">person_add</v-icon></router-link>
                </template>
                <template v-if="!isDeleteDisabled(props.item)">
                  <a @click.stop="deleteAuctionDialog(props.item)"><v-icon size="x-large" color="grey lighten-1">delete</v-icon></a>
                </template>
                <template v-if="!isCancelDisabled(props.item)">
                  <a @click.stop="cancelAuctionDialog(props.item)"><v-icon size="x-large" color="grey lighten-1">block</v-icon></a>
                </template>
              </td>
            </tr>

            <tr v-if="props.expanded" class="data-table-expanded-row">
              <td class="data-container">
                <div class="sub">Principal Seller</div>
                <div v-if="props.item.sellerProfile.id">
                  {{ props.item.sellerProfile.firstName }} {{ props.item.sellerProfile.lastName }}
                </div>
                <div v-else>
                  &mdash;
                </div>
                <div class="sub margin-top">Delegated Agents</div>
                <template v-if="delegatedAgentProfiles.length > 0">
                  <ul v-for="item in delegatedAgentProfiles" :key="item.userId">
                    <a class="brokerInfo" @click.stop="openAgentCardDialog({ agentProfile: item, tenantSubdomain: $store.state.tenant.subdomain })">
                      <li class="brokerInfo">
                        {{ item.firstName }} {{ item.lastName }}
                      </li>
                    </a>
                  </ul>
                </template>
                <template v-else>
                  &mdash;
                </template>
                <div class="margin-top"><router-link :to="'/auction/' + props.item.id">Go To Auction Page &gt;</router-link></div>
              </td>

              <td class="data-container">
                <div class="sub">Review Bidders</div>
                <div>Approved: {{ props.item.participants.buyer + props.item.participants.winner + props.item.participants.abandon }}</div>
                <div>Pending: {{ props.item.participants.applicant }}</div>
                <div class="margin-top">
                  <router-link :to="'/dashboard/bidders/' + props.item.id">
                    Review All Bidders ({{ props.item.participants.applicant + props.item.participants.buyer + props.item.participants.winner + props.item.participants.abandon }}) &gt;
                  </router-link>
                </div>
              </td>

              <td class="data-container">
                <div class="sub">Starting Price</div>
                <div>{{ props.item.startingPrice | prettyMoney }}</div>
                <template>
                  <div class="sub margin-top">Reserve Price</div>
                  <div>{{ props.item.reservePrice | prettyMoney }}</div>
                </template>
              </td>

              <td class="data-container">
                <div class="sub">Ends</div>
                <div>{{ props.item.endDate | prettyDateTimeShort(props.item.metadata.timezone) }}</div>
              </td>

              <td colspan="2" class="data-container">
                <div class="sub">Registration Period</div>
                <div>{{ props.item.publishDate | prettyDateTimeShort(props.item.metadata.timezone) }}</div>
                <div>{{ props.item.freezeDate | prettyDateTimeShort(props.item.metadata.timezone) }}</div>
              </td>
            </tr>

          </template>
        </v-data-table>
        <WithTutorial
          name="DashboardTutorial" :order="2"
          heading="Welcome to PFX!"
          text="This is where you will find information about your auction such as the property,
          the amount of bidders who are approved (or pending your approval) to the auction,
          the period and status or other auction details."
          placement="bottom" block>
          <span></span>
        </WithTutorial>
      </div>

      <div v-if="showDelegateAgentSection()">
        <div class="clearfix">
          <hr>
          <div>
            <h2>Delegated</h2>
          </div>
        </div>

        <div v-if="auctionsForDelegateAgent.length > 0">
          <fieldset class="col-14">
            <v-text-field v-model="delegatedSearch" label="Search" single-line hide-details ></v-text-field>
          </fieldset>
        </div>

        <!-- <template v-if="auctionsForDelegateAgent > 0"> -->
        <v-data-table class="dashboard" :search="delegatedSearch" :headers="headersForDelegateAgent" :pagination.sync="paginationForDelegateAgent" :items="auctionsForDelegateAgent" must-sort hide-actions item-key="id">
          <template slot="items" slot-scope="props">
            <tr @click="props.expanded = !props.expanded;loadDataForDelegatedgAgent(props.item.id)" style="cursor:pointer;">
              <td>
                <div class="clearfix data-table-property-info">
                  <div class="photo-container" :style="'background-image: url(' + auctionPhoto(props.item) + ');'">
                  </div>
                  <div class="data-container">
                    <div class="sub">{{ auctionTypeLabel(props.item.metadata.type) }}</div>
                    <div class="address">{{ props.item.address }}</div>
                    <div>
                      <a @click.stop="openAgentCardDialog({ agentProfile: props.item.listingAgentProfile, tenantSubdomain: $store.state.tenant.subdomain })">
                        {{ props.item.listingAgentProfile.firstName }} {{ props.item.listingAgentProfile.lastName }}
                      </a>
                    </div>
                  </div>
                </div>
              </td>

              <td>
                <div style="display: inline-block; margin-right: .5rem;">{{ props.item.participants.applicant + props.item.participants.buyer + props.item.participants.winner + props.item.participants.abandon }}</div>
                <div class="bidders-pill" v-if="props.item.participants.applicant > 0"><router-link :to="'/dashboard/bidders/' + props.item.id">{{ props.item.participants.applicant }} Pending</router-link></div>
              </td>

              <td>
                <template v-if="props.item.status === auctionStatuses.PROCESSING.value || props.item.status === auctionStatuses.IN_ESCROW.value || props.item.status === auctionStatuses.SOLD.value || props.item.status === auctionStatuses.CANCELLED.value || props.item.status === auctionStatuses.CLOSED.value">
                  <div class="sub">Highest Bid</div>
                </template>
                <template v-else>
                  <div class="sub">Current Bid</div>
                </template>
                <div>
                  {{ props.item.currentPrice | prettyMoney }}
                  <span v-if="props.item.injected.bids.length > 0" style="text-decoration: underline; margin-left: .5em;" @click.stop="$store.commit('openBidsDialog', props.item.id)">{{ props.item.injected.bids.length }} Bids</span>
                </div>
              </td>

              <td>
                <div class="sub">Start</div>
                <div>{{ props.item.startDate | prettyDateTimeShort(props.item.metadata.timezone) }}</div>
              </td>

              <td>
                <template v-if="props.item.status === auctionStatuses.OPEN.value || props.item.status === auctionStatuses.FREEZE.value">
                  <div class="sub">{{ props.item.startDate | delta | countdownTimer }}</div>
                </template>
                <template v-else-if="props.item.status === auctionStatuses.AUCTION.value">
                  <div class="sub">{{ props.item.endDate | delta | countdownTimer }}</div>
                </template>
                <AuctionStatusIndicator :auction="props.item" />
                <template v-if="props.item.injected.winner.alias">
                  <div class="winner-pill">{{ props.item.injected.winner.alias }}</div>
                </template>
              </td>

              <td class="actions">
                <template v-if="!isEditDisabled(props.item)">
                  <router-link :to="'/dashboard/create/' + props.item.id"><v-icon size="x-large" color="grey lighten-1">edit</v-icon></router-link>
                </template>
                <template v-if="!isEditDisabled(props.item)">
                  <router-link :to="'/dashboard/delegate/' + props.item.id"><v-icon size="x-large" color="grey lighten-1">person_add</v-icon></router-link>
                </template>
                <template v-if="!isDeleteDisabled(props.item)">
                  <a @click.stop="deleteAuctionDialog(props.item)"><v-icon size="x-large" color="grey lighten-1">delete</v-icon></a>
                </template>
                <template v-if="!isCancelDisabled(props.item)">
                  <a @click.stop="cancelAuctionDialog(props.item)"><v-icon size="x-large" color="grey lighten-1">block</v-icon></a>
                </template>
              </td>
            </tr>

            <tr v-if="props.expanded" class="data-table-expanded-row">
              <td class="data-container">
                <div class="sub">Principal Seller</div>
                <div v-if="props.item.sellerProfile.id">
                  {{ props.item.sellerProfile.firstName }} {{ props.item.sellerProfile.lastName }}
                </div>
                <div v-else>
                  &mdash;
                </div>
                <div class="sub margin-top">Delegated Agents</div>
                <template v-if="delegatedAgentProfiles.length > 0">
                  <ul v-for="item in delegatedAgentProfiles" :key="item.userId">
                    <a class="brokerInfo" @click.stop="openAgentCardDialog({ agentProfile: item, tenantSubdomain: $store.state.tenant.subdomain })">
                      <li class="brokerInfo">
                        {{ item.firstName }} {{ item.lastName }}
                      </li>
                    </a>
                  </ul>
                </template>
                <template v-else>
                  &mdash;
                </template>
                <div class="margin-top"><router-link :to="'/auction/' + props.item.id">Go To Auction Page &gt;</router-link></div>
              </td>

              <td class="data-container">
                <div class="sub">Review Bidders</div>
                <div>Approved: {{ props.item.participants.buyer + props.item.participants.winner + props.item.participants.abandon }}</div>
                <div>Pending: {{ props.item.participants.applicant }}</div>
                <div class="margin-top">
                  <router-link :to="'/dashboard/bidders/' + props.item.id">
                    Review All Bidders ({{ props.item.participants.applicant + props.item.participants.buyer + props.item.participants.winner + props.item.participants.abandon }}) &gt;
                  </router-link>
                </div>
              </td>

              <td class="data-container">
                <div class="sub">Starting Price</div>
                <div>{{ props.item.startingPrice | prettyMoney }}</div>
                <template>
                  <div class="sub margin-top">Reserve Price</div>
                  <div>{{ props.item.reservePrice | prettyMoney }}</div>
                </template>
              </td>

              <td class="data-container">
                <div class="sub">Ends</div>
                <div>{{ props.item.endDate | prettyDateTimeShort(props.item.metadata.timezone) }}</div>
              </td>

              <td colspan="2" class="data-container">
                <div class="sub">Registration Period</div>
                <div>{{ props.item.publishDate | prettyDateTimeShort(props.item.metadata.timezone) }}</div>
                <div>{{ props.item.freezeDate | prettyDateTimeShort(props.item.metadata.timezone) }}</div>
              </td>
            </tr>

          </template>
        </v-data-table>
        <!-- </template>
        <template v-else>
          <div>You do not have delegated auction activities.</div>
        </template> -->
      </div>

      <div v-if="auctionRolesForBuyer.length > 0">
        <hr>
        <h3>Auctions on PFX</h3>
        <h2>Buyer</h2>

        <div v-if="auctionRolesForBuyer.length > 0">
          <fieldset class="col-14">
            <v-text-field v-model="buyerSearch" label="Search" single-line hide-details ></v-text-field>
          </fieldset>
        </div>

        <v-data-table class="dashboard" :search="buyerSearch" :headers="headers" :pagination.sync="pagination" :items="auctionRolesForBuyer" must-sort hide-actions item-key="id">
          <template slot="items" slot-scope="props">
            <tr @click="props.expanded = !props.expanded" style="cursor:pointer;">

              <td class="align-center">
                <img class="data-table-company-logo" :src="tenantLogoUrl(props.item.injected.tenant)" />
              </td>

              <td>
                <div class="clearfix data-table-property-info">
                  <div class="photo-container" :style="'background-image: url(' + auctionPhoto(props.item.target) + ');'">
                  </div>
                  <div class="data-container">
                    <div class="sub">{{ auctionTypeLabel(props.item.target.metadata.type) }}</div>
                    <div class="address">{{ props.item.target.address }}</div>
                    <div>
                      <a @click.stop="openAgentCardDialog({ agentProfile: props.item.injected.listingAgent, tenantSubdomain: props.item.injected.tenant.subdomain })">
                        {{ props.item.injected.listingAgent.firstName }} {{ props.item.injected.listingAgent.lastName }}
                      </a>
                    </div>
                  </div>
                </div>
              </td>


              <td class="nowrap">
                <div class="draft-pill" v-if="props.item.role === auctionRoles.ENTRY.value">
                  <router-link :to="registrationFormLink(props.item, props.item.target.id)">Draft</router-link>
                  <v-icon size="small">arrow_forward</v-icon>
                </div>
                <div class="pending-pill" v-else-if="props.item.role === auctionRoles.APPLICANT.value">
                  <router-link :to="registrationFormLink(props.item, props.item.target.id)">Pending</router-link>
                  <v-icon size="small">arrow_forward</v-icon>
                </div>
                <div class="approved-pill" v-else-if="props.item.role === auctionRoles.BUYER.value">
                  <router-link :to="registrationFormLink(props.item, props.item.target.id)">Approved</router-link>
                  <v-icon size="small">arrow_forward</v-icon>
                </div>
                <div class="disqualified-pill" v-else-if="props.item.role === auctionRoles.DISQUALIFIED.value">
                  <router-link :to="registrationFormLink(props.item, props.item.target.id)">Disqualified</router-link>
                  <v-icon size="small">arrow_forward</v-icon>
                </div>
                <div class="abandoned-pill" v-else-if="props.item.role === auctionRoles.ABANDON.value">
                  <router-link :to="registrationFormLink(props.item, props.item.target.id)">Approved</router-link>
                  <v-icon size="small">arrow_forward</v-icon>
                </div>
                <div class="winner-pill" v-else-if="props.item.role === auctionRoles.WINNER.value">
                  <router-link :to="registrationFormLink(props.item, props.item.target.id)">Winner</router-link>
                  <v-icon size="small">arrow_forward</v-icon>
                </div>
                <div class="draft-pill" v-else>
                  UNKNOWN
                </div>

                <div style="font-size: 11px; color: #777;">Last Updated {{ props.item.lastModified | prettyDateShort }}</div>
              </td>


              <td class="nowrap">
                <template v-if="props.item.target.status === auctionStatuses.OPEN.value || props.item.target.status === auctionStatuses.FREEZE.value">
                  <div class="sub">Starting Price</div>
                  <div>{{ props.item.target.startingPrice | prettyMoney }}</div>
                  <template v-if="props.item.injected.autobid.status === 'PENDING'">
                    <div class="sub margin-top">Autobid</div>
                    <div>Up to {{ props.item.injected.autobid.threshold | prettyMoney }}</div>
                  </template>
                </template>

                <template v-else-if="props.item.target.status === auctionStatuses.AUCTION.value">
                  <div class="sub">Current Bid</div>
                  <div>
                    {{ props.item.target.currentPrice | prettyMoney }}
                    <span style="text-decoration: underline; margin-left: .5em;" @click.stop="$store.commit('openBidsDialog', props.item.target.id)">{{ props.item.injected.bids.length }} Bids</span>
                  </div>
                  <div class="sub margin-top">My Last Bid</div>
                  <div>{{ myHighestBid(props.item.userId, props.item.injected.bids) | prettyMoney }} </div>
                  <template v-if="props.item.injected.autobid.status === 'ACTIVE'">
                    <div class="sub margin-top">Autobid</div>
                    <div>Up to {{ props.item.injected.autobid.threshold | prettyMoney }}</div>
                  </template>
                </template>

                <template v-else-if="props.item.target.status === auctionStatuses.PROCESSING.value || props.item.target.status === auctionStatuses.IN_ESCROW.value || props.item.target.status === auctionStatuses.SOLD.value || props.item.target.status === auctionStatuses.CANCELLED.value || props.item.target.status === auctionStatuses.CLOSED.value">
                  <div class="sub">Highest Bid</div>
                  <div>
                    {{ props.item.target.currentPrice | prettyMoney }}
                    <span style="text-decoration: underline; margin-left: .5em;" @click.stop="$store.commit('openBidsDialog', props.item.target.id)">{{ props.item.injected.bids.length }} Bids</span>
                  </div>
                  <div class="sub margin-top">My Last Bid</div>
                  <div>{{ myHighestBid(props.item.userId, props.item.injected.bids) | prettyMoney }} </div>
                </template>
              </td>

              <td class="nowrap">
                <div class="sub">Start</div>
                <div>{{ props.item.target.startDate | prettyDateTimeShort(props.item.target.metadata.timezone) }}</div>
              </td>

              <td class="nowrap">
                <template v-if="props.item.target.status === auctionStatuses.OPEN.value || props.item.target.status === auctionStatuses.FREEZE.value">
                  <div class="sub">{{ props.item.target.startDate | delta | countdownTimer }}</div>
                </template>
                <template v-else-if="props.item.target.status === auctionStatuses.AUCTION.value">
                  <div class="sub">{{ props.item.target.endDate | delta | countdownTimer }}</div>
                </template>
                <AuctionStatusIndicator :auction="props.item.target" />
                <template v-if="props.item.target.injected.winner.alias">
                  <div class="winner-pill">{{ props.item.target.injected.winner.alias }}</div>
                </template>
              </td>
              
              <td class="actions">
                <div v-if="isAutobidEnabled(props.item.target)" >
                  <div @click.stop="openAutobidDialog(props.item.target.id)">
                    <v-icon :color="''">gavel</v-icon> Autobid
                  </div>
                </div>
              </td>
            </tr>

            <tr v-if="props.expanded" class="data-table-expanded-row">
              <td></td>

              <td class="data-container">
                <div class="sub">Listing Agent</div>
                <div>{{ props.item.injected.listingAgent.firstName }} {{ props.item.injected.listingAgent.lastName }}</div>
                <div class="sub margin-top">Observers</div>
                <div v-for="observer in props.item.injected.observers" :key="observer.id">
                  {{ observer.profile.firstName }} {{ observer.profile.lastName }} <small>({{ auctionRoleLabel(observer.role) }})</small>
                </div>
                <div v-if="props.item.injected.observers.length === 0">&mdash;</div>
                <div class="bold-link margin-top"><a @click="clickAuction(props.item)">Go to Auction Page &gt;</a></div>
              </td>

              <td class="data-container">
                <div class="sub">Registration Status</div>
                <div>{{ auctionRoleLabel(props.item.role) }}</div>
                <div class="sub margin-top">Representation</div>
                <div v-if="props.item.injected.sellingAgent.role">
                  {{ props.item.injected.sellingAgent.profile.firstName }} {{ props.item.injected.sellingAgent.profile.lastName }}
                  <small>({{ auctionRoleLabel(props.item.injected.sellingAgent.role) }})</small>
                </div>
                <div v-else>
                  &mdash;
                </div>
                <div class="bold-link margin-top">
                  <div v-if="props.item.injected.buyer.auctionRole.role === auctionRoles.ENTRY.value || props.item.injected.buyer.auctionRole.role === auctionRoles.APPLICANT.value">
                    <router-link :to="registrationFormLink(props.item, props.item.target.id)">Edit / View Form &gt;</router-link>
                  </div>
                  <div v-else>
                    <router-link :to="registrationFormLink(props.item, props.item.target.id)">View Form &gt;</router-link>
                  </div>
                </div>
              </td>

              <td class="data-container">
                <div class="sub">Starting Price</div>
                <div>{{ props.item.target.startingPrice | prettyMoney }}</div>
                <template v-if="props.item.target.metadata.hideReservePrice !== true">
                  <div class="sub margin-top">Reserve Price</div>
                  <div>{{ props.item.target.reservePrice | prettyMoney }}</div>
                </template>
              </td>

              <td class="data-container">
                <div class="sub">End</div>
                {{ props.item.target.endDate | prettyDateTimeShort(props.item.target.metadata.timezone) }}<br/>
              </td>

              <td class="data-container">
                <div class="sub">Registration Period</div>
                {{ props.item.target.publishDate | prettyDateTimeShort(props.item.target.metadata.timezone) }}<br/>
                {{ props.item.target.freezeDate | prettyDateTimeShort(props.item.target.metadata.timezone) }}<br/>
              </td>
            </tr>

          </template>
        </v-data-table>
      </div>

      <div v-if="auctionRolesForObserver.length > 0">
        <hr>
        <h3>Auctions on PFX</h3>
        <h2>Observer</h2>

        <div v-if="auctionRolesForObserver.length > 0">
          <fieldset class="col-14">
            <v-text-field v-model="observerSearch" label="Search" single-line hide-details ></v-text-field>
          </fieldset>
        </div>

        <v-data-table class="dashboard" :search="observerSearch" :headers="headersForObserver" :pagination.sync="paginationForObserver" :items="auctionRolesForObserver" must-sort hide-actions item-key="id">
          <template slot="items" slot-scope="props">
            <tr @click="props.expanded = !props.expanded" style="cursor:pointer;">

              <td class="align-center">
                <img class="data-table-company-logo" :src="tenantLogoUrl(props.item.injected.tenant)" />
              </td>

              <td>
                <div class="clearfix data-table-property-info">
                  <div class="photo-container" :style="'background-image: url(' + auctionPhoto(props.item.target) + ');'">
                  </div>
                  <div class="data-container">
                    <div class="sub">{{ auctionTypeLabel(props.item.target.metadata.type) }}</div>
                    <div class="address">{{ props.item.target.address }}</div>
                    <div>
                      <a @click.stop="openAgentCardDialog({ agentProfile: props.item.injected.listingAgent, tenantSubdomain: props.item.injected.tenant.subdomain })">
                        {{ props.item.injected.listingAgent.firstName }} {{ props.item.injected.listingAgent.lastName }}
                      </a>
                    </div>
                  </div>
                </div>
              </td>

              <td class="nowrap">
                <div>{{ props.item.injected.buyer.injectedProfile.firstName }} {{ props.item.injected.buyer.injectedProfile.lastName }}</div>
                <div class="alias">{{ props.item.injected.buyer.injectedProfile.alias }}</div>

                <div class="draft-pill" v-if="props.item.injected.buyer.auctionRole.role === auctionRoles.ENTRY.value">Draft</div>
                <div class="pending-pill" v-else-if="props.item.injected.buyer.auctionRole.role === auctionRoles.APPLICANT.value">Pending</div>
                <div class="approved-pill" v-else-if="props.item.injected.buyer.auctionRole.role === auctionRoles.BUYER.value">Approved</div>
                <div class="disqualified-pill" v-else-if="props.item.injected.buyer.auctionRole.role === auctionRoles.DISQUALIFIED.value">Disqualified</div>
                <div class="abandoned-pill" v-else-if="props.item.injected.buyer.auctionRole.role === auctionRoles.ABANDON.value">Approved</div>
                <div class="winner-pill" v-else-if="props.item.injected.buyer.auctionRole.role === auctionRoles.WINNER.value">Winner</div>
                <div class="draft-pill" v-else>UNKNOWN</div>

                <div style="font-size: 11px; color: #777;">Last Updated {{ props.item.lastModified | prettyDateShort }}</div>
              </td>

              <td class="nowrap">
                <template v-if="props.item.target.status === auctionStatuses.OPEN.value || props.item.target.status === auctionStatuses.FREEZE.value">
                  <div class="sub">Starting Price</div>
                  <div>{{ props.item.target.startingPrice | prettyMoney }}</div>
                  <template v-if="props.item.injected.autobid.status === 'PENDING'">
                    <div class="sub">Autobid</div>
                    <div>Up to {{ props.item.injected.autobid.threshold | prettyMoney }}</div>
                  </template>
                </template>

                <template v-else-if="props.item.target.status === auctionStatuses.AUCTION.value">
                  <div class="sub">Current Bid</div>
                  <div>
                    {{ props.item.target.currentPrice | prettyMoney }}
                    <span style="text-decoration: underline; margin-left: .5em;" @click.stop="$store.commit('openBidsDialog', props.item.target.id)">{{ props.item.injected.bids.length }} Bids</span>
                  </div>
                  <div class="sub margin-top">Last Bid</div>
                  <div>{{ myHighestBid(props.item.injected.buyer.injectedProfile.id, props.item.injected.bids) | prettyMoney }}</div>
                  <template v-if="props.item.injected.autobid.status === 'ACTIVE'">
                    <div class="sub margin-top">Autobid</div>
                    <div>Up to {{ props.item.injected.autobid.threshold | prettyMoney }}</div>
                  </template>
                </template>

                <template v-else-if="props.item.target.status === auctionStatuses.PROCESSING.value || props.item.target.status === auctionStatuses.IN_ESCROW.value || props.item.target.status === auctionStatuses.SOLD.value || props.item.target.status === auctionStatuses.CANCELLED.value || props.item.target.status === auctionStatuses.CLOSED.value">
                  <div class="sub">Highest Bid</div>
                  <div>
                    {{ props.item.target.currentPrice | prettyMoney }}
                    <span style="text-decoration: underline; margin-left: .5em;" @click.stop="$store.commit('openBidsDialog', props.item.target.id)">{{ props.item.injected.bids.length }} Bids</span>
                  </div>
                  <div class="sub margin-top">Last Bid</div>
                  <div>{{ myHighestBid(props.item.injected.buyer.injectedProfile.id, props.item.injected.bids) | prettyMoney }}</div>
                </template>
              </td>

              <td class="nowrap">
                <div class="sub">Start</div>
                <div>{{ props.item.target.startDate | prettyDateTimeShort(props.item.target.metadata.timezone) }}</div>
              </td>

              <td class="nowrap">
                <template v-if="props.item.target.status === auctionStatuses.OPEN.value || props.item.target.status === auctionStatuses.FREEZE.value">
                  <div class="sub">{{ props.item.target.startDate | delta | countdownTimer }}</div>
                </template>
                <template v-else-if="props.item.target.status === auctionStatuses.AUCTION.value">
                  <div class="sub">{{ props.item.target.endDate | delta | countdownTimer }}</div>
                </template>
                <AuctionStatusIndicator :auction="props.item.target" />
                <template v-if="props.item.target.injected.winner.alias">
                  <div class="winner-pill">{{ props.item.target.injected.winner.alias }}</div>
                </template>
              </td>
            </tr>

            <tr v-if="props.expanded" class="data-table-expanded-row">
              <td></td>

              <td class="data-container">
                <div class="sub">Listing Agent</div>
                <div>{{ props.item.injected.listingAgent.firstName }} {{ props.item.injected.listingAgent.lastName }}</div>
                <div class="sub margin-top">Observers</div>
                <div v-for="observer in props.item.injected.observers" :key="observer.id">
                  {{ observer.profile.firstName }} {{ observer.profile.lastName }} <small>({{ auctionRoleLabel(observer.role) }})</small>
                </div>
                <div v-if="props.item.injected.observers.length === 0">&mdash;</div>
                <div class="bold-link margin-top"><a @click="clickAuction(props.item)">Go to Auction Page &gt;</a></div>
              </td>

              <td class="data-container">
                <div class="sub">Registration Status</div>
                <div>{{ auctionRoleLabel(props.item.injected.buyer.auctionRole.role) }}</div>
                <div class="sub margin-top">Representation</div>
                <div v-if="props.item.injected.sellingAgent.role">
                  {{ props.item.injected.sellingAgent.profile.firstName }} {{ props.item.injected.sellingAgent.profile.lastName }}
                  <small>({{ auctionRoleLabel(props.item.injected.sellingAgent.role) }})</small>
                </div>
                <div v-else>
                  &mdash;
                </div>
                <div class="bold-link margin-top"><router-link :to="registrationFormLink(props.item, props.item.target.id)">View Form &gt;</router-link></div>
              </td>

              <td class="data-container">
                <div class="sub">Starting Price</div>
                <div>{{ props.item.target.startingPrice | prettyMoney }}</div>
                <template v-if="props.item.target.metadata.hideReservePrice !== true">
                  <div class="sub margin-top">Reserve Price</div>
                  <div>{{ props.item.target.reservePrice | prettyMoney }}</div>
                </template>
              </td>

              <td class="data-container">
                <div class="sub">End</div>
                {{ props.item.target.endDate | prettyDateTimeShort(props.item.target.metadata.timezone) }}<br/>
              </td>

              <td class="data-container">
                <div class="sub">Registration Period</div>
                {{ props.item.target.publishDate | prettyDateTimeShort(props.item.target.metadata.timezone) }}<br/>
                {{ props.item.target.freezeDate | prettyDateTimeShort(props.item.target.metadata.timezone) }}<br/>
              </td>
            </tr>

          </template>
        </v-data-table>
      </div>

      <div v-if="auctionRolesForSeller.length > 0">
        <hr>
        <h3>Assets on PFX</h3>
        <h2>Seller</h2>

        <div v-if="auctionRolesForSeller.length > 0">
          <fieldset class="col-14">
            <v-text-field v-model="sellerSearch" label="Search" single-line hide-details ></v-text-field>
          </fieldset>
        </div>
        
        <v-data-table class="dashboard" :search="sellerSearch" :headers="headersForSeller" :pagination.sync="paginationForSeller" :items="auctionRolesForSeller" must-sort hide-actions item-key="id">
          <template slot="items" slot-scope="props">
            <tr @click="props.expanded = !props.expanded" style="cursor:pointer;">

              <td class="align-center">
                <img class="data-table-company-logo" :src="tenantLogoUrl(props.item.injected.tenant)" />
              </td>

              <td>
                <div class="clearfix data-table-property-info">
                  <div class="photo-container" :style="'background-image: url(' + auctionPhoto(props.item.target) + ');'">
                  </div>
                  <div class="data-container">
                    <div class="sub">{{ auctionTypeLabel(props.item.target.metadata.type) }}</div>
                    <div class="address">{{ props.item.target.address }}</div>
                    <div>
                      <a @click.stop="openAgentCardDialog({ agentProfile: props.item.injected.listingAgent, tenantSubdomain: props.item.injected.tenant.subdomain })">
                        {{ props.item.injected.listingAgent.firstName }} {{ props.item.injected.listingAgent.lastName }}
                      </a>
                    </div>
                  </div>
                </div>
              </td>

              <td class="nowrap">
                <div>{{ props.item.target.participants.buyer + props.item.target.participants.winner + props.item.target.participants.abandon }}</div>
              </td>

              <td class="nowrap">
                <template v-if="props.item.target.status === auctionStatuses.OPEN.value || props.item.target.status === auctionStatuses.FREEZE.value">
                  <div class="sub">Starting Price</div>
                  <div>{{ props.item.target.startingPrice | prettyMoney }}</div>
                </template>

                <template v-else-if="props.item.target.status === auctionStatuses.AUCTION.value">
                  <div class="sub">Current Bid</div>
                  <div>
                    {{ props.item.target.currentPrice | prettyMoney }}
                    <span style="text-decoration: underline; margin-left: .5em;" @click.stop="$store.commit('openBidsDialog', props.item.target.id)">{{ props.item.injected.bids.length }} Bids</span>
                  </div>
                </template>

                <template v-else-if="props.item.target.status === auctionStatuses.PROCESSING.value || props.item.target.status === auctionStatuses.IN_ESCROW.value || props.item.target.status === auctionStatuses.SOLD.value || props.item.target.status === auctionStatuses.CANCELLED.value || props.item.target.status === auctionStatuses.CLOSED.value">
                  <div class="sub">Highest Bid</div>
                  <div>
                    {{ props.item.target.currentPrice | prettyMoney }}
                    <span style="text-decoration: underline; margin-left: .5em;" @click.stop="$store.commit('openBidsDialog', props.item.target.id)">{{ props.item.injected.bids.length }} Bids</span>
                  </div>
                </template>
              </td>

              <td class="nowrap">
                <div class="sub">Start</div>
                <div>{{ props.item.target.startDate | prettyDateTimeShort(props.item.target.metadata.timezone) }}</div>
              </td>

              <td class="nowrap">
                <template v-if="props.item.target.status === auctionStatuses.OPEN.value || props.item.target.status === auctionStatuses.FREEZE.value">
                  <div class="sub">{{ props.item.target.startDate | delta | countdownTimer }}</div>
                </template>
                <template v-else-if="props.item.target.status === auctionStatuses.AUCTION.value">
                  <div class="sub">{{ props.item.target.endDate | delta | countdownTimer }}</div>
                </template>
                <AuctionStatusIndicator :auction="props.item.target" />
                <template v-if="props.item.target.injected.winner.alias">
                  <div class="winner-pill">{{ props.item.target.injected.winner.alias }}</div>
                </template>
              </td>
            </tr>

            <tr v-if="props.expanded" class="data-table-expanded-row">
              <td></td>

              <td class="data-container">
                <div class="sub">Listing Agent</div>
                <div>{{ props.item.injected.listingAgent.firstName }} {{ props.item.injected.listingAgent.lastName }}</div>
                <div class="bold-link margin-top"><a @click="clickAuction(props.item)">Go to Auction Page &gt;</a></div>
              </td>

              <td class="data-container">
              </td>

              <td class="data-container">
                <div class="sub">Starting Price</div>
                <div>{{ props.item.target.startingPrice | prettyMoney }}</div>
                <div class="sub margin-top">Reserve Price</div>
                <div>{{ props.item.target.reservePrice | prettyMoney }}</div>
              </td>

              <td class="data-container">
                <div class="sub">End</div>
                {{ props.item.target.endDate | prettyDateTimeShort(props.item.target.metadata.timezone) }}<br/>
              </td>

              <td class="data-container">
                <div class="sub">Registration Period</div>
                {{ props.item.target.publishDate | prettyDateTimeShort(props.item.target.metadata.timezone) }}<br/>
                {{ props.item.target.freezeDate | prettyDateTimeShort(props.item.target.metadata.timezone) }}<br/>
              </td>
            </tr>

          </template>
        </v-data-table>
      </div>

      <div v-if="auctionRolesForSellingAgent.length > 0">
        <hr>
        <h3>Principals on PFX</h3>
        <h2>Selling Agent</h2>

        <div v-if="auctionRolesForSellingAgent.length > 0">
          <fieldset class="col-14">
            <v-text-field v-model="sellingAgentSearch" label="Search" single-line hide-details ></v-text-field>
          </fieldset>
        </div>

        <v-data-table class="dashboard" :search="sellingAgentSearch" :headers="headersForSellingAgent" :pagination.sync="paginationForSellingAgent" :items="auctionRolesForSellingAgent" must-sort hide-actions item-key="id">
          <template slot="items" slot-scope="props">
            <tr @click="props.expanded = !props.expanded" style="cursor:pointer;">

              <td class="align-center">
                <img class="data-table-company-logo" :src="tenantLogoUrl(props.item.injected.tenant)" />
              </td>

              <td>
                <div class="clearfix data-table-property-info">
                  <div class="photo-container" :style="'background-image: url(' + auctionPhoto(props.item.target) + ');'">
                  </div>
                  <div class="data-container">
                    <div class="sub">{{ auctionTypeLabel(props.item.target.metadata.type) }}</div>
                    <div class="address">{{ props.item.target.address }}</div>
                    <div>
                      <a @click.stop="openAgentCardDialog({ agentProfile: props.item.injected.listingAgent, tenantSubdomain: props.item.injected.tenant.subdomain })">
                        {{ props.item.injected.listingAgent.firstName }} {{ props.item.injected.listingAgent.lastName }}
                      </a>
                    </div>
                  </div>
                </div>
              </td>

              <td class="nowrap">
                <div>{{ props.item.injected.buyer.injectedProfile.firstName }} {{ props.item.injected.buyer.injectedProfile.lastName }}</div>
                <div class="alias">{{ props.item.injected.buyer.injectedProfile.alias }}</div>

                <div class="draft-pill" v-if="props.item.injected.buyer.auctionRole.role === auctionRoles.ENTRY.value">
                  <router-link :to="registrationFormLink(props.item.injected.buyer.auctionRole, props.item.target.id)">Draft</router-link>
                  <v-icon size="small">arrow_forward</v-icon>
                </div>
                <div class="pending-pill" v-else-if="props.item.injected.buyer.auctionRole.role === auctionRoles.APPLICANT.value">
                  <router-link :to="registrationFormLink(props.item.injected.buyer.auctionRole, props.item.target.id)">Pending</router-link>
                  <v-icon size="small">arrow_forward</v-icon>
                </div>
                <div class="approved-pill" v-else-if="props.item.injected.buyer.auctionRole.role === auctionRoles.BUYER.value">
                  <router-link :to="registrationFormLink(props.item.injected.buyer.auctionRole, props.item.target.id)">Approved</router-link>
                  <v-icon size="small">arrow_forward</v-icon>
                </div>
                <div class="disqualified-pill" v-else-if="props.item.injected.buyer.auctionRole.role === auctionRoles.DISQUALIFIED.value">
                  <router-link :to="registrationFormLink(props.item.injected.buyer.auctionRole, props.item.target.id)">Disqualified</router-link>
                  <v-icon size="small">arrow_forward</v-icon>
                </div>
                <div class="abandoned-pill" v-else-if="props.item.injected.buyer.auctionRole.role === auctionRoles.ABANDON.value">
                  <router-link :to="registrationFormLink(props.item.injected.buyer.auctionRole, props.item.target.id)">Approved</router-link>
                  <v-icon size="small">arrow_forward</v-icon>
                </div>
                <div class="winner-pill" v-else-if="props.item.injected.buyer.auctionRole.role === auctionRoles.WINNER.value">
                  <router-link :to="registrationFormLink(props.item.injected.buyer.auctionRole, props.item.target.id)">Winner</router-link>
                  <v-icon size="small">arrow_forward</v-icon>
                </div>
                <div class="draft-pill" v-else>
                  UNKNOWN
                </div>

                <div style="font-size: 11px; color: #777;">Last Updated {{ props.item.lastModified | prettyDateShort }}</div>
              </td>

              <td class="nowrap">
                <template v-if="props.item.target.status === auctionStatuses.OPEN.value || props.item.target.status === auctionStatuses.FREEZE.value">
                  <div class="sub">Starting Price</div>
                  <div>{{ props.item.target.startingPrice | prettyMoney }}</div>
                  <template v-if="props.item.injected.autobid.status === 'PENDING'">
                    <div class="sub">Autobid</div>
                    <div>Up to {{ props.item.injected.autobid.threshold | prettyMoney }}</div>
                  </template>
                </template>

                <template v-else-if="props.item.target.status === auctionStatuses.AUCTION.value">
                  <div class="sub">Current Bid</div>
                  <div>
                    {{ props.item.target.currentPrice | prettyMoney }}
                    <span style="text-decoration: underline; margin-left: .5em;" @click.stop="$store.commit('openBidsDialog', props.item.target.id)">{{ props.item.injected.bids.length }} Bids</span>
                  </div>
                  <div class="sub margin-top">Last Bid</div>
                  <div>{{ myHighestBid(props.item.injected.buyer.injectedProfile.id, props.item.injected.bids) | prettyMoney }}</div>
                  <template v-if="props.item.injected.autobid.status === 'ACTIVE'">
                    <div class="sub margin-top">Autobid</div>
                    <div>Up to {{ props.item.injected.autobid.threshold | prettyMoney }}</div>
                  </template>
                </template>

                <template v-else-if="props.item.target.status === auctionStatuses.PROCESSING.value || props.item.target.status === auctionStatuses.IN_ESCROW.value || props.item.target.status === auctionStatuses.SOLD.value || props.item.target.status === auctionStatuses.CANCELLED.value || props.item.target.status === auctionStatuses.CLOSED.value">
                  <div class="sub">Highest Bid</div>
                  <div>
                    {{ props.item.target.currentPrice | prettyMoney }}
                    <span style="text-decoration: underline; margin-left: .5em;" @click.stop="$store.commit('openBidsDialog', props.item.target.id)">{{ props.item.injected.bids.length }} Bids</span>
                  </div>
                  <div class="sub margin-top">Last Bid</div>
                  <div>{{ myHighestBid(props.item.injected.buyer.injectedProfile.id, props.item.injected.bids) | prettyMoney }}</div>
                </template>
              </td>

              <td class="nowrap">
                <div class="sub">Start</div>
                <div>{{ props.item.target.startDate | prettyDateTimeShort(props.item.target.metadata.timezone) }}</div>
              </td>

              <td class="nowrap">
                <template v-if="props.item.target.status === auctionStatuses.OPEN.value || props.item.target.status === auctionStatuses.FREEZE.value">
                  <div class="sub">{{ props.item.target.startDate | delta | countdownTimer }}</div>
                </template>
                <template v-else-if="props.item.target.status === auctionStatuses.AUCTION.value">
                  <div class="sub">{{ props.item.target.endDate | delta | countdownTimer }}</div>
                </template>
                <AuctionStatusIndicator :auction="props.item.target" />
                <template v-if="props.item.target.injected.winner.alias">
                  <div class="winner-pill">{{ props.item.target.injected.winner.alias }}</div>
                </template>
              </td>
            </tr>

            <tr v-if="props.expanded" class="data-table-expanded-row">
              <td></td>

              <td class="data-container">
                <div class="sub">Listing Agent</div>
                <div>{{ props.item.injected.listingAgent.firstName }} {{ props.item.injected.listingAgent.lastName }}</div>
                <div class="sub margin-top">Observers</div>
                <div v-for="observer in props.item.injected.observers" :key="observer.id">
                  {{ observer.profile.firstName }} {{ observer.profile.lastName }} <small>({{ auctionRoleLabel(observer.role) }})</small>
                </div>
                <div v-if="props.item.injected.observers.length === 0">&mdash;</div>
                <div class="bold-link margin-top"><a @click="clickAuction(props.item)">Go to Auction Page &gt;</a></div>
              </td>

              <td class="data-container">
                <div class="sub">Registration Status</div>
                <div>{{ auctionRoleLabel(props.item.injected.buyer.auctionRole.role) }}</div>
                <div class="sub margin-top">Representation</div>
                <div>
                  {{ props.item.injected.sellingAgent.profile.firstName }} {{ props.item.injected.sellingAgent.profile.lastName }}
                  <small>({{ auctionRoleLabel(props.item.injected.sellingAgent.role) }})</small>
                </div>
                <div class="bold-link margin-top">
                  <router-link :to="registrationFormLink(props.item.injected.buyer.auctionRole, props.item.target.id)">View Form &gt;</router-link>
                </div>
              </td>

              <td class="data-container">
                <div class="sub">Starting Price</div>
                <div>{{ props.item.target.startingPrice | prettyMoney }}</div>
                <template v-if="props.item.target.metadata.hideReservePrice !== true">
                  <div class="sub margin-top">Reserve Price</div>
                  <div>{{ props.item.target.reservePrice | prettyMoney }}</div>
                </template>
              </td>

              <td class="data-container">
                <div class="sub">End</div>
                {{ props.item.target.endDate | prettyDateTimeShort(props.item.target.metadata.timezone) }}<br/>
              </td>

              <td class="data-container">
                <div class="sub">Registration Period</div>
                {{ props.item.target.publishDate | prettyDateTimeShort(props.item.target.metadata.timezone) }}<br/>
                {{ props.item.target.freezeDate | prettyDateTimeShort(props.item.target.metadata.timezone) }}<br/>
              </td>
            </tr>

          </template>
        </v-data-table>
      </div>

      <div v-if="auctionsForWatchlist.length > 0">
        <hr>
        <h2>Watchlist</h2>
        <div class="clearfix" v-if="auctionsForWatchlist.length > 0">

          <div v-if="auctionsForWatchlist.length > 0">
            <fieldset class="col-14">
              <v-text-field v-model="watchlistSearch" label="Search" single-line hide-details ></v-text-field>
            </fieldset>
          </div>

          <v-data-table class="dashboard" :search="watchlistSearch" :headers="headersForWatchlist" :pagination.sync="paginationForWatchlist" :items="auctionsForWatchlist" must-sort hide-actions item-key="id">
            <template slot="items" slot-scope="props">
              <tr @click="$router.push('/auction/' + props.item.id)" style="cursor:pointer;">

                <td class="align-center">
                  <img class="data-table-company-logo" :src="tenantLogoUrl(props.item.tenantProfile)" />
                </td>

                <td>
                  <div class="clearfix data-table-property-info">
                    <div class="photo-container" :style="'background-image: url(' + auctionPhoto(props.item) + ');'">
                    </div>
                    <div class="data-container">
                      <div class="sub">{{ auctionTypeLabel(props.item.metadata.type) }}</div>
                      <div class="address">{{ props.item.address }}</div>
                      <div>
                        <a @click.stop="openAgentCardDialog({ agentProfile: props.item.listingAgentProfile, tenantSubdomain: props.item.tenantProfile.subdomain })">
                          {{ props.item.listingAgentProfile.firstName }} {{ props.item.listingAgentProfile.lastName }}
                        </a>
                      </div>
                    </div>
                  </div>
                </td>

                <td class="nowrap">
                  <div>{{ props.item.participants.buyer + props.item.participants.winner + props.item.participants.abandon }}</div>
                </td>

                <td class="nowrap">
                  <template v-if="props.item.status === auctionStatuses.OPEN.value || props.item.status === auctionStatuses.FREEZE.value">
                    <div class="sub">Starting Price</div>
                    <div>{{ props.item.startingPrice | prettyMoney }}</div>
                  </template>

                  <template v-else-if="props.item.status === auctionStatuses.AUCTION.value">
                    <div class="sub">Current Bid</div>
                    <div>
                      {{ props.item.currentPrice | prettyMoney }}
                      <span style="text-decoration: underline; margin-left: .5em;" @click.stop="$store.commit('openBidsDialog', props.item.id)">{{ props.item.injected.bids.length }} Bids</span>
                    </div>
                  </template>

                  <template v-else-if="props.item.status === auctionStatuses.PROCESSING.value || props.item.status === auctionStatuses.IN_ESCROW.value || props.item.status === auctionStatuses.SOLD.value || props.item.target.status === auctionStatuses.CANCELLED.value || props.item.target.status === auctionStatuses.CLOSED.value">
                    <div class="sub">Highest Bid</div>
                    <div>
                      {{ props.item.currentPrice | prettyMoney }}
                      <span style="text-decoration: underline; margin-left: .5em;" @click.stop="$store.commit('openBidsDialog', props.item.id)">{{ props.item.injected.bids.length }} Bids</span>
                    </div>
                  </template>
                </td>

                <td class="nowrap">
                  <div class="sub">Start</div>
                  <div>{{ props.item.startDate | prettyDateTimeShort(props.item.metadata.timezone) }}</div>
                </td>

                <td class="nowrap">
                  <template v-if="props.item.status === auctionStatuses.OPEN.value || props.item.status === auctionStatuses.FREEZE.value">
                    <div class="sub">{{ props.item.startDate | delta | countdownTimer }}</div>
                  </template>
                  <template v-else-if="props.item.status === auctionStatuses.AUCTION.value">
                    <div class="sub">{{ props.item.endDate | delta | countdownTimer }}</div>
                  </template>
                  <AuctionStatusIndicator :auction="props.item" />
                  <template v-if="props.item.injected.winner.alias">
                    <div class="winner-pill">{{ props.item.injected.winner.alias }}</div>
                  </template>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
        <div v-else class="no-content-container no-content-text">
          <div>Your watchlist is currently empty.</div>
          <div>You can add them by clicking a bookmark icon on interesting auctions.</div>
        </div>

      </div>

    </div>

    <template>
      <DashboardAutoBidWidget :initialAuction="selectedAuction" />
    </template>
  </div>
</template>

<script>
  import AuctionStatusIndicator from './elements/AuctionStatusIndicator.vue'
  import AgentCardDialog from './elements/AgentCardDialog.vue'
  import TutorialToggle from './elements/TutorialToggle.vue'
  import WithTutorial from './elements/WithTutorial.vue'
  import tutorialMixin from '../mixins/tutorialMixin.js'
  import AuctionBids from './AuctionBids.vue'
  import { auctionRoles, auctionRoleLabel, auctionStatuses, auctionTypeLabel, tenantLogoUrl } from '../utils/PfxUtils.js'
  import { mapGetters, mapMutations } from 'vuex'
  import AutoBidWidget from './elements/AutoBidWidget.vue'
  import DashboardAutoBidWidget from './elements/DashboardAutoBidWidget.vue'

  export default {
    name: 'MyAuctions',
    components: {
      AuctionStatusIndicator,
      AgentCardDialog,
      AuctionBids,
      TutorialToggle,
      WithTutorial,
      AutoBidWidget,
      DashboardAutoBidWidget
    },
    mixins: [
      tutorialMixin('DashboardTutorial')
    ],
    data() {
      return {
        auctionStatuses,
        auctionRoles,

        ...mapGetters([]),
        officeAssistantSearch: '',
        listingAgentSearch: '',
        delegatedSearch: '',
        buyerSearch: '',
        observerSearch: '',
        sellerSearch: '',
        sellingAgentSearch: '',
        watchlistSearch: '',
        
        selectedAuction: {},
        delegatedAgentProfiles: [],
        search: '',
        auctionRolesForBuyer: [],
        headers: [
          { text: 'Broker', align: 'center', value: 'target.tenant.subdomain' },
          { text: 'Property', align: 'left', value: 'target.address' },
          { text: 'Registration', align: 'left', value: 'role' },
          { text: 'Bids', align: 'left', value: 'target.currentPrice' },
          { text: 'Auction Period', align: 'left', value: 'target.startDate' },
          { text: 'Status', align: 'left', value: 'target.status' },
          { text: 'Actions', align: 'left', sortable: false}
        ],
        pagination: {
          sortBy: 'target.startDate', descending: true, rowsPerPage: 100000000
        },

        tenantMembers: [], // this is used for resolving agent's delegate
        auctionsForListingAgent: [],
        headersForListingAgent: [
          { text: 'Property', align: 'left', value: 'address' },
          { text: 'Bidders', align: 'left', value: 'participants.total' },
          { text: 'Bids', align: 'left', value: 'currentPrice' },
          { text: 'Auction Period', align: 'left', value: 'startDate' },
          { text: 'Status', align: 'left', value: 'status' },
          { text: 'Actions', align: 'left', sortable: false }
        ],
        paginationForListingAgent: {
          sortBy: 'startDate', descending: true, rowsPerPage: 100000000
        },

        auctionsForAssistant: [],
        headersForAssistant: [
          { text: 'Property', align: 'left', value: 'address' },
          { text: 'Address', align: 'left', value: 'address' },
          { text: 'Start Date', align: 'left', value: 'startDate' },
          { text: 'End Date', align: 'left', value: 'endDate' },
          { text: 'Status', align: 'left', value: 'status' },
          { text: 'Actions', align: 'left', sortable: false }
        ],
        paginationForAssistant: {
          sortBy: 'startDate', descending: true, rowsPerPage: 100000000
        },

        auctionsForDelegateAgent: [],
        headersForDelegateAgent: [
          { text: 'Property', align: 'left', value: 'address' },
          { text: 'Bidders', align: 'left', value: 'participants.total' },
          { text: 'Bids', align: 'left', value: 'currentPrice' },
          { text: 'Auction Period', align: 'left', value: 'startDate' },
          { text: 'Status', align: 'left', value: 'status' },
          { text: 'Actions', align: 'left', sortable: false }
        ],
        paginationForDelegateAgent: {
          sortBy: 'startDate', descending: true, rowsPerPage: 100000000
        },

        auctionRolesForObserver: [],
        headersForObserver: [
          { text: 'Broker', align: 'left', value: 'target.tenant.subdomain' },
          { text: 'Property', align: 'left', value: 'target.address' },
          { text: 'Principal', align: 'left', value: 'injected.buyer.injectedProfile.lastName' },
          { text: 'Bids', align: 'left', value: 'currentPrice' },
          { text: 'Auction Period', align: 'left', value: 'target.startDate' },
          { text: 'Status', align: 'left', value: 'status' }
        ],
        paginationForObserver: {
          sortBy: 'target.startDate', descending: true, rowsPerPage: 100000000
        },

        auctionRolesForSeller: [],
        headersForSeller: [
          { text: 'Broker', align: 'left', value: 'target.tenant.subdomain' },
          { text: 'Property', align: 'left', value: 'target.address' },
          { text: 'Bidders', align: 'left', value: 'target.participants.buyer' },
          { text: 'Bids', align: 'left', value: 'currentPrice' },
          { text: 'Auction Period', align: 'left', value: 'target.startDate' },
          { text: 'Status', align: 'left', value: 'status' }
        ],
        paginationForSeller: {
          sortBy: 'target.startDate', descending: true, rowsPerPage: 100000000
        },

        auctionRolesForSellingAgent: [],
        headersForSellingAgent: [
          { text: 'Broker', align: 'left', value: 'target.tenant.subdomain' },
          { text: 'Property', align: 'left', value: 'target.address' },
          { text: 'Principal', align: 'left', value: 'injected.buyer.injectedProfile.lastName' },
          { text: 'Bids', align: 'left', value: 'currentPrice' },
          { text: 'Auction Period', align: 'left', value: 'target.startDate' },
          { text: 'Status', align: 'left', value: 'status' }
        ],
        paginationForSellingAgent: {
          sortBy: 'target.startDate', descending: true, rowsPerPage: 100000000
        },

        auctionsForWatchlist: [],
        headersForWatchlist: [
          { text: 'Broker', align: 'left', value: 'target.tenant.subdomain' },
          { text: 'Property', align: 'left', value: 'target.address' },
          { text: 'Bidders', align: 'left', value: 'target.participants.buyer' },
          { text: 'Bids', align: 'left', value: 'currentPrice' },
          { text: 'Auction Period', align: 'left', value: 'target.startDate' },
          { text: 'Status', align: 'left', value: 'status' }
        ],
        paginationForWatchlist: {
          sortBy: 'target.startDate', descending: true, rowsPerPage: 100000000
        },

        agentCache: {},
        tenantCache: {},

        cancelDialogVisible: {
          visible: false,
          auction: null,
          reason: ''
        }
      }
    },
    created() {
      this.refreshPage()
    },
    mounted() {
      // subscribe to auction events
      this.$events.on('auction', updatedAuction => {
        this.auctionRolesForBuyer.forEach(ar => {
          if (ar.target.id === updatedAuction.id) {
            Object.assign(ar.target, updatedAuction)
            this.reloadBids(ar.target, ar.injected.bids)
          }
        })
        this.auctionRolesForObserver.forEach(ar => {
          if (ar.target.id === updatedAuction.id) {
            Object.assign(ar.target, updatedAuction)
            this.reloadBids(ar.target, ar.injected.bids)
          }
        })
        this.auctionRolesForSellingAgent.forEach(ar => {
          if (ar.target.id === updatedAuction.id) {
            Object.assign(ar.target, updatedAuction)
            this.reloadBids(ar.target, ar.injected.bids)
          }
        })
        this.auctionRolesForSeller.forEach(ar => {
          if (ar.target.id === updatedAuction.id) {
            Object.assign(ar.target, updatedAuction)
            this.reloadBids(ar.target, ar.injected.bids)
          }
        })
        this.auctionsForListingAgent.forEach(au => {
          if (au.id === updatedAuction.id) {
            Object.assign(au, updatedAuction)
            this.reloadBids(au, au.injected.bids)
          }
        })
        this.auctionsForDelegateAgent.forEach(au => {
          if (au.id === updatedAuction.id) {
            Object.assign(au, updatedAuction)
            this.reloadBids(au, au.injected.bids)
          }
        })
      })
      this.refresher()
    },
    beforeDestroy() {
      this.$events.off('auction')
    },
    methods: {
      tenantLogoUrl,
      auctionRoleLabel,
      auctionTypeLabel,

      ...mapMutations([
        'openAgentCardDialog',
        'setAllowAutoBid',
        'showAutoBidDialog'
      ]),

     

      refreshPage() {
        this.loadData()
        this.loadDataForAssistant()
        this.loadDataForListingAgent()
        this.loadDataForWatchlist()
      },

      refresher() {
        // touch a auction attribute -> forces updating the view (countdownTimers)
        this.auctionsForListingAgent.forEach(auction => (auction.address += ' ').trim())
        this.auctionRolesForBuyer.forEach(auctionRole => (auctionRole.target.address += ' ').trim())
        this.auctionRolesForObserver.forEach(auctionRole => (auctionRole.target.address += ' ').trim())
        this.auctionRolesForSeller.forEach(auctionRole => (auctionRole.target.address += ' ').trim())
        this.auctionRolesForSellingAgent.forEach(auctionRole => (auctionRole.target.address += ' ').trim())
        setTimeout(this.refresher, 1000)
      },

      showListingAgentSection() {
        const myRole = this.$store.state.user.role
        const myTenant = this.$store.state.user.tenant
        const thisTenant = this.$store.state.tenant.subdomain
        return myTenant === thisTenant && (myRole === 'ADMIN' || myRole === 'AGENT')
      },

      showAssistantSection() {
        const myRole = this.$store.state.user.role
        const myTenant = this.$store.state.user.tenant
        const thisTenant = this.$store.state.tenant.subdomain
        return myTenant === thisTenant && myRole === 'ASSISTANT'
      },

      showDelegateAgentSection() {
        const myRole = this.$store.state.user.role
        const myTenant = this.$store.state.user.tenant
        const thisTenant = this.$store.state.tenant.subdomain
        return myTenant === thisTenant && (myRole === 'ADMIN' || myRole === 'AGENT')
      },

       openAutobidDialog(auctionId){
        this.$PfxBackendApi.getAuction(auctionId)
          .then(res => {
            console.log('auction res', res)
            this.selectedAuction = res.data || {}
            this.setAllowAutoBid(true)
            this.showAutoBidDialog(true)
          })
          .catch(err => {
            console.error('getAuction res error', err)
          })
      },

      isDashboardEmpty() {
        return !(this.auctionRolesForBuyer.length
          || this.auctionsForListingAgent.length
          || this.auctionsForDelegateAgent.length
          || this.auctionsForAssistant.length
          || this.auctionRolesForSellingAgent.length
          || this.auctionRolesForObserver.length
          || this.auctionRolesForSeller.length)
      },

      isEditDisabled(auction) {
        return auction.status !== auctionStatuses.DRAFT.value && auction.status !== auctionStatuses.OPEN.value
          && auction.status !== auctionStatuses.FREEZE.value
      },

      isDeleteDisabled(auction) {
        if (auction.biddersAccepted > 0 || auction.biddersNew > 0 || auction.biddersTotal > 0) return true
        if (auction.participants.entry > 0 || auction.participants.applicant > 0 || auction.participants.buyer > 0 || auction.participants.winner > 0) return true
        return false
      },

      isCancelDisabled(auction) {
        return auction.status !== auctionStatuses.OPEN.value && auction.status !== auctionStatuses.FREEZE.value && auction.status !== auctionStatuses.AUCTION.value && auction.status !== auctionStatuses.PROCESSING.value
      },

      isAutobidEnabled(auction){
        return auction.metadata.allowAutobids && auction.status === auctionStatuses.AUCTION.value
      },

      loadData() {
        this.auctionRolesForBuyer = []
        this.auctionRolesForObserver = []
        this.auctionRolesForSellingAgent = []
        this.auctionRolesForSeller = []

        const that = this
        that.$store.commit('setLoadingSpinner', true)
        this.$PfxBackendApi.getMyAuctions()
          .then(res => {
            console.log('getMyAuctions res', res)
            let applications = res.data.data || []

            // Filter auction roles to reduce amount of network traffic
            applications = applications.filter(a => {
              return a.role === auctionRoles.ENTRY.value ||
                a.role === auctionRoles.APPLICANT.value ||
                a.role === auctionRoles.DISQUALIFIED.value ||
                a.role === auctionRoles.BUYER.value ||
                a.role === auctionRoles.WINNER.value ||
                a.role === auctionRoles.ABANDON.value ||
                a.role === auctionRoles.SELLING_AGENT.value ||
                a.role === auctionRoles.BUYER_OBSERVER.value ||
                a.role === auctionRoles.SELLER.value ||
                a.role === auctionRoles.DELEGATE.value
            })
            // Filter by auction status
            applications = applications.filter(a => {
              return a.target.status !== auctionStatuses.ARCHIVED.value
            })

            applications.forEach(application => {
              const iAmObserver = application.role === auctionRoles.BUYER_OBSERVER.value
              const iAmSellingAgent = application.role === auctionRoles.SELLING_AGENT.value
              const iAmBuyer = application.role === auctionRoles.ENTRY.value || application.role === auctionRoles.APPLICANT.value || application.role === auctionRoles.DISQUALIFIED.value || application.role === auctionRoles.BUYER.value || application.role === auctionRoles.WINNER.value || application.role === auctionRoles.ABANDON.value
              const iAmSeller = application.role === auctionRoles.SELLER.value
              console.debug('loadData role [%s] auction [%s] iAmObserver [%s] iAmSellingAgent [%s] iAmBuyer [%s] iAmSeller [%s]', application.id, application.target.id, iAmObserver, iAmSellingAgent, iAmBuyer, iAmSeller)

              if (iAmObserver || iAmSellingAgent) { // i'm a selling agent or observer => resolve my associated buyer(s) here
                this.$PfxBackendApi
                  .getAuctionBuyers(application.target.tenant.subdomain, application.target.id, application.id)
                  .then(res => {
                    console.log('getAuctionBuyers res', res)
                    const buyers = res.data || []
                    buyers.forEach(buyer => {
                      const cloned = JSON.parse(JSON.stringify(application))
                      this.loadSingleApplication(iAmObserver ? this.auctionRolesForObserver : this.auctionRolesForSellingAgent, cloned, buyer)
                    })
                  })
                  .catch(err => {
                    console.error('getAuctionBuyers err', err)
                    this.$notify({
                      type: 'danger',
                      message: 'Cannot fetch data about buyers for auction #' + application.target.id
                    })
                  })
              } else if (iAmSeller) {
                this.loadSingleApplication(this.auctionRolesForSeller, application, application)
              } else if (iAmBuyer) {
                this.loadSingleApplication(this.auctionRolesForBuyer, application, application)
              }
            })
          })
          .catch(err => {
            console.error('getMyAuctions err', err)
            this.$notify({ type: 'danger', message: 'Cannot fetch data about auctions'})
          })
          .then(() => that.$store.commit('setLoadingSpinner', false))
      },

      loadDataForDelegatedgAgent(auctionId){
        this.loading1++
        // const auctionId = this.initialAuction.id
        this.$PfxBackendApi.getAuctionDelegatedAgents(auctionId).then(res => {
          if (res.data) {
            console.info('getAuctionDelegatedAgents res:', res) // res.data = { id, email, firstName, lastName, phone, photoUrl }
            this.delegatedAgentProfiles = res.data
          }
        }).catch(err => {
          console.error('getAuctionDelegatedAgents error:', err)
        }).then(() => this.loading1--)
      },

      loadSingleApplication(targetArray, application, buyerApplication) {
        application.injected = {}
        application.injected.tenant = {}
        application.injected.listingAgent = {}
        application.injected.sellingAgent = {}
        application.injected.observers = []
        application.injected.bids = []
        application.injected.autobid = {}
        application.injected.buyer = { auctionRole: buyerApplication, injectedProfile: {} }
        application.target.injected = {}

        //const iAmBuyer = application.role === auctionRoles.ENTRY.value || application.role === auctionRoles.APPLICANT.value || application.role === auctionRoles.DISQUALIFIED.value || application.role === auctionRoles.BUYER.value || application.role === auctionRoles.WINNER.value || application.role === auctionRoles.ABANDON.value
        //const iAmApprovedBuyer = application.role === auctionRoles.BUYER.value || application.role === auctionRoles.WINNER.value || application.role === auctionRoles.ABANDON.value
        //const iAmCollaborator = application.role === auctionRoles.SELLING_AGENT.value || application.role === auctionRoles.BUYER_OBSERVER.value

        // use cached tenant - read tenant profile just once
        this.getTenantProfile(application.target.tenant.subdomain)
          .then(res => { application.injected.tenant = res })
          .catch(err => {
            console.error('getTenantProfile error', err)
          })

        // use cached user for listing agent - read user profile just once
        this.getUserProfile(application.target.listingAgent)
          .then(res => { application.injected.listingAgent = res || {} })
          .catch(err => {console.error('getUserProfile (listingAgent) err', err)})

        // use cached user for collaborators (selling agent)
        this.$PfxBackendApi
          .getAuctionSellingAgent(application.target.tenant.subdomain, application.target.id, buyerApplication.id)
          .then(res => {
            console.log('getAuctionSellingAgent res', res)
            const role = (res.data && res.data.sellingAgentRole) || {}
            if (role.id) {
              this.getUserProfile(role.userId)
                .then(res => {
                  console.log('getUserProfile (sellingAgent) res', res)
                  application.injected.sellingAgent = { id: role.id, role: role.role, profile: res }
                })
                .catch(err => { console.error('getUserProfile (sellingAgent) err', err) })
            }
          })
          .catch(err => {
            console.error('getAuctionSellingAgent err', err)
          })

        // use cached user for collaborators (buyer observers)
        this.$PfxBackendApi
          .getAuctionBuyerObservers(application.target.tenant.subdomain, application.target.id, buyerApplication.id)
          .then(res => {
            console.log('getAuctionBuyerObservers res', res)
            if (res.data && Array.isArray(res.data) && res.data.length > 0) {
              res.data.forEach(data => {
                const role = (data && data.observerRole) || {}
                if (role.id) {
                  this.getUserProfile(role.userId)
                    .then(res => {
                      console.log('getUserProfile (buyerObserver) res', res)
                      application.injected.observers.push({ id: role.id, role: role.role, profile: res } ) })
                    .catch(err => { console.error('getUserProfile (buyerObserver) err', err) })
                }
              })
            }
          })
          .catch(err => {
            console.error('getAuctionBuyerObservers err', err)
          })

        // Only fetch bids for certain auction statuses (omitted otherwise from ui)
        if (application.target.status === auctionStatuses.AUCTION.value
          || application.target.status === auctionStatuses.PROCESSING.value
          || application.target.status === auctionStatuses.IN_ESCROW.value
          || application.target.status === auctionStatuses.CLOSED.value
          || application.target.status === auctionStatuses.SOLD.value
          || application.target.status === auctionStatuses.CANCELLED.value) {
          this.reloadBids(application.target, application.injected.bids)
        }

        // fetch current autobid data
        const role = application.role
        const status = application.target.status
        const iCanSeeAutobid = role === auctionRoles.BUYER.value || role === auctionRoles.BUYER_OBSERVER.value || role === auctionRoles.SELLING_AGENT.value
        if (iCanSeeAutobid && (status === auctionStatuses.OPEN.value || status === auctionStatuses.FREEZE.value || status === auctionStatuses.AUCTION.value)) {
          this.$PfxBackendApi
            .readAutoBid(application.target.tenant.subdomain, application.target.id, buyerApplication.id)
            .then(res => {
              console.info('readAutoBid res [%s]', buyerApplication.id, res)
              application.injected.autobid = res.data || {}
            })
            .catch(err => {
              if (err.status === 404) {
                console.info('readAutoBid (404) [%s] err', buyerApplication.id, err)
              } else {
                console.error('readAutoBid [%s] err', buyerApplication.id, err)
                this.$notify({ type: 'danger', message: 'Cannot fetch data about autobids' })
              }
            })
        }

        // get buyer profile
        this.getUserProfile(buyerApplication.userId).then(res => {
          console.log('getUserProfile (buyer) res', res)
          application.injected.buyer.injectedProfile = res || {}
        }).catch(err => {
          console.error('getUserProfile (buyer) err', err)
        })

        // inject winner
        this.loadParticipants(application.target)

        targetArray.push(application)
      },

      reloadBids(auction, targetBidArray) {
        while (targetBidArray.length > 0) targetBidArray.splice(0, 1)
        this.$PfxBackendApi
          .getBidsForAuction(auction.tenant.subdomain, auction.id)
          .then(res => {
            console.info('getBidsForAuction res', res)
            res.data.forEach(element => targetBidArray.push(element))
          })
          .catch(err => {
            console.error('getBidsForAuction err', err)
            this.$notify({ type: 'danger', message: 'Cannot fetch data about bids' })
          })
      },

      loadDataForListingAgent() {
        const that = this
        this.auctionsForListingAgent = []
        this.tenantMembers = []

        if (!this.showListingAgentSection()) {
          return
        }

        this.$PfxBackendApi.getTenantMembers()
          .then(res => {
            console.log('getTenantMembers res', res)
            this.tenantMembers = res.data || []
          })
          .catch(err => console.error('getTenantMembers err', err))

        this.$PfxBackendApi.getPrincipals()
          .then(res => {
            console.log('getPrincipals res', res)
            const meAndDelegates = res.data || []
            meAndDelegates.forEach(agent => {

              this.$PfxBackendApi.getListings(agent.userId).then(res => {
                console.info('getListings for [%s][%s] res', agent.userId, agent.email, res)
                let auctionRoles = res.data.data || []

                // filter out by auctions status (do not display archived)
                auctionRoles = auctionRoles.filter(a =>
                  a.target.status !== auctionStatuses.ARCHIVED.value
                )

                const auctions = []
                auctionRoles.forEach(auctionRole => auctions.push(auctionRole.target))

                if (auctions.length) {
                  auctions.forEach(auction => {
                    auction.injected = {}
                    auction.tenantProfile = {}
                    auction.listingAgentProfile = {}
                    auction.delegateProfile = {}
                    auction.sellerProfile = {}
                    auction.injected.bids = []

                    that.loadParticipants(auction)
                    that.loadSeller(auction)
                    that.getTenantProfile(auction.tenant.subdomain)
                      .then(res => { auction.tenantProfile = res || {} })
                      .catch(err => { console.error('getTenantProfile err', err) })
                    that.getUserProfile(auction.listingAgent)
                      .then(res => { auction.listingAgentProfile = res || {} })
                      .catch(err => { console.error('getUserProfile err', err) })
                    that.getDelegateFor(auction.listingAgent)
                      .then(res => { auction.delegateProfile = res || {} })

                    // fetch bids
                    this.reloadBids(auction, auction.injected.bids)
                  })
                  that.auctionsForListingAgent = that.auctionsForListingAgent.concat(auctions)
                }
              }).catch(err => {
                console.error('getListings err', err)
                this.$notify({ type: 'danger', message: 'Cannot fetch data about listings' })
              }).then(() => this.$store.commit('setLoadingSpinner', false))

              this.$PfxBackendApi.getDelegated(agent.userId).then(res => {
                console.info('getDelegated for [%s][%s] res', agent.userId, agent.email, res)
                let auctionRoles = res.data.data || []

                // filter out by auctions status (do not display archived)
                auctionRoles = auctionRoles.filter(a =>
                  a.target.status !== auctionStatuses.ARCHIVED.value
                )

                const auctions = []
                auctionRoles.forEach(auctionRole => auctions.push(auctionRole.target))

                if (auctions.length) {
                  auctions.forEach(auction => {
                    auction.injected = {}
                    auction.tenantProfile = {}
                    auction.listingAgentProfile = {}
                    auction.delegateProfile = {}
                    auction.sellerProfile = {}
                    auction.injected.bids = []

                    that.loadParticipants(auction)
                    that.loadSeller(auction)
                    that.getTenantProfile(auction.tenant.subdomain)
                      .then(res => { auction.tenantProfile = res || {} })
                      .catch(err => { console.error('getTenantProfile err', err) })
                    that.getUserProfile(auction.listingAgent)
                      .then(res => { auction.listingAgentProfile = res || {} })
                      .catch(err => { console.error('getUserProfile err', err) })
                    that.getDelegateFor(auction.listingAgent)
                      .then(res => { auction.delegateProfile = res || {} })

                    // fetch bids
                    this.reloadBids(auction, auction.injected.bids)
                  })
                  that.auctionsForDelegateAgent = that.auctionsForDelegateAgent.concat(auctions)
                }
              }).catch(err => {
                console.error('getDelegated err', err)
                this.$notify({ type: 'danger', message: 'Cannot fetch data about delegated' })
              }).then(() => this.$store.commit('setLoadingSpinner', false))
            })
          })
          .catch(err => console.error('getPrincipals err', err))
      },

      loadDataForAssistant() {
        const that = this
        this.auctionsForAssistant = []

        if (!this.showAssistantSection()) {
          return
        }

        this.$PfxBackendApi.getAllAuctions().then(res => {
          console.info('getAllAuctions res', res)
          let auctions = res.data.data || []

          // filter out by auctions status (do not display archived)
          auctions = auctions.filter(a =>
            a.status !== auctionStatuses.ARCHIVED.value
          )

          // const auctions = []
          // auctionRoles.forEach(auctionRole => auctions.push(auctionRole.target))

          if (auctions.length) {
            auctions.forEach(auction => {
              auction.injected = {}
              auction.tenantProfile = {}
              auction.listingAgentProfile = {}

              that.getTenantProfile(auction.tenant.subdomain)
                .then(res => { auction.tenantProfile = res || {} })
                .catch(err => { console.error('getTenantProfile err', err) })
              that.getUserProfile(auction.listingAgent)
                .then(res => { auction.listingAgentProfile = res || {} })
                .catch(err => { console.error('getUserProfile err', err) })
            })
            that.auctionsForAssistant = that.auctionsForAssistant.concat(auctions)
          }
        }).catch(err => {
          console.error('getAllAuctions err', err)
          this.$notify({ type: 'danger', message: 'Cannot fetch data about all auctions' })
        }).then(() => this.$store.commit('setLoadingSpinner', false))

      },

      loadParticipants(auction) {
        auction.biddersNew = auction.participants.applicant
        auction.biddersAccepted = auction.participants.buyer + auction.participants.winner + auction.participants.abandon
        auction.biddersTotal = auction.participants.total - auction.participants.entry

        auction.injected.winner = {}
        if (auction.participants.winner === 1) {
          this.$PfxBackendApi.getAuctionWinner(auction.tenant.subdomain, auction.id).then(res => {
            console.log('getAuctionWinner res', res)
            auction.injected.winner = res.data || {}
          }).catch(err => {
            console.error('getAuctionWinner [%s] err', auction.id, err)
          })
        }
      },

      loadSeller(auction) {
        this.$PfxBackendApi.getAuctionParticipants(auction.tenant.subdomain, auction.id)
          .then(res => {
            console.debug('getAuctionParticipants (seller) [%s] res', auction.id, res)
            const roles = res.data || []
            const sellers = roles.filter(ar => ar.role === auctionRoles.SELLER.value)
            if (sellers.length > 0) {
              this.getUserProfile(sellers[0].userId)
                .then(data => {
                  auction.sellerProfile = data
                  console.log('loadSeller', auction.sellerProfile)
                })
                .catch(err => console.error('getUserProfile (seller) err', err))
            }
          })
          .catch(err => console.error('getAuctionParticipants (seller) [%s] err', auction.id, err))
      },

      loadDataForWatchlist() {
        this.auctionsForWatchlist = []
        this.$PfxBackendApi.getWatchlistAuctions()
          .then(res => {
            console.log('getWatchlistAuctions res', res)
            const auctions = res.data.data || []
            auctions.forEach(auction => {
              auction.injected = {}
              auction.tenantProfile = {}
              auction.listingAgentProfile = {}
              auction.delegateProfile = {}
              auction.injected.bids = []

              this.loadParticipants(auction)
              this.getTenantProfile(auction.tenant.subdomain)
                .then(res => { auction.tenantProfile = res || {} })
                .catch(err => { console.error('getTenantProfile err', err) })
              this.getUserProfile(auction.listingAgent)
                .then(res => { auction.listingAgentProfile = res || {} })
                .catch(err => { console.error('getUserProfile err', err) })
              this.getDelegateFor(auction.listingAgent)
                .then(res => { auction.delegateProfile = res || {} })

              // fetch bids
              this.reloadBids(auction, auction.injected.bids)

              this.auctionsForWatchlist.push(auction)
            })
          })
          .catch(err => {
            this.$notify({type: 'danger', message: 'Error loading watchlist'})
            console.error('getWatchlistAuctions err', err)
          })
      },

      getUserProfile(userId) {
        return new Promise((resolve, reject) => {
          if (this.agentCache[userId]) {
            resolve(this.agentCache[userId])
            return
          }
          this.agentCache[userId] = {}
          this.$PfxBackendApi
            .getUser(userId)
            .then(res => {
              console.info('getUser (listingAgent) res', res)
              Object.assign(this.agentCache[userId], res.data || {})
              resolve(this.agentCache[userId])
            })
            .catch(err => {
              console.error('getUser (listingAgent) err', err)
              this.$notify({ type: 'danger', message: 'Cannot fetch listing agent profile' })
              reject(err)
            })
        })
      },

      getTenantProfile(subdomain) {
        return new Promise((resolve, reject) => {
          if (this.tenantCache[subdomain]) {
            resolve(this.tenantCache[subdomain])
            return
          }
          this.tenantCache[subdomain] = {}
          this.$PfxBackendApi
            .getTenantPublic(subdomain)
            .then(res => {
              console.info('getTenantPublic res', res)
              Object.assign(this.tenantCache[subdomain], res.data || {})
              resolve(this.tenantCache[subdomain])
              this.$forceUpdate()
            })
            .catch(err => {
              console.error('getTenantPublic error', err)
              reject(err)
            })
        })
      },

      getDelegateFor(userId) {
        return new Promise((resolve) => {
          this.tenantMembers.forEach(member => {
            if (member.userId === userId) {
              if (member.delegate) {
                this.getUserProfile(member.delegate)
                  .then(res => {
                    console.log('getUserProfile (delegate) res', res)
                    resolve(res || {})
                  })
                  .catch(err => {
                    console.error('getUserProfile (delegate) err', err)
                    resolve({})
                  })
              } else {
                resolve({})
              }
            }
          })
        })
      },

      auctionPhoto(auction) {
        if (auction && auction.metadata && auction.metadata.photos && Array.isArray(auction.metadata.photos) && auction.metadata.photos.length > 0) {
          return auction.metadata.photos[0]
        }
        return require('../assets/placeholder-photos.jpg')
      },

      clickAuction(auctionRole) {
        if (auctionRole.role === auctionRoles.WINNER.value) {
          this.$router.push('/winner/' + auctionRole.target.id + '/' + auctionRole.id)
        } else {
          this.$router.push('/auction/' + auctionRole.target.id)
        }
      },

      registrationFormLink(auctionRole, auctionId) {
        if (auctionRole.role === 'WINNER') {
          return '/winner/' + auctionId + '/' + auctionRole.id
        } else {
          return '/application/' + auctionId + '/' + auctionRole.id
        }
      },

      myHighestBid(userId, bids) {
        if (!userId || !bids || bids.length === 0) { return 0 }
        let highest = 0
        bids = bids.filter(bid => bid.userId === userId)
        bids.forEach(bid => {
          if (bid.amount > highest) {
            highest = bid.amount
          }
        })
        return highest
      },

      deleteAuctionDialog(auction) {
        this.$store.commit('openDialog', {
          text: 'You are about to permanently delete the auction (' + auction.address + '). This cannot be undone. ' +
          'Are you sure?',
          buttons: [
            { title: 'Cancel', class: 'btn-neutral' },
            {
              title: 'Delete auction', class: 'btn-danger',
              handler: () => {
                this.$store.commit('closeDialog')
                this.deleteAuction(auction)
              }
            }
          ]
        })
      },

      deleteAuction(auction) {
        this.$PfxBackendApi.deleteAuction(auction.id).then(res => {
          console.log('deleteAuction res', res)
          this.refreshPage()
        }).catch(err => {
          console.error('deleteAuction err', err)
          this.$notify({ type: 'danger', message: 'Cannot delete the auction' })
        })
      },

      cancelAuctionDialog(auction) {
        this.cancelDialogVisible = { visible: true, auction, reason: '' }
      },

      cancelAuction() {
        if (this.cancelDialogVisible.auction.id > 0 && this.cancelDialogVisible.reason.length > 0) {
          this.$store.commit('setLoadingSpinner', true)
          this.$PfxBackendApi.cancelAuction(this.cancelDialogVisible.auction.id, this.cancelDialogVisible.reason).then(res => {
            console.log('cancelAuction res', res)
            this.cancelDialogVisible.visible = false
            this.refreshPage()
          }).catch(err => {
            console.error('cancelAuction err', err)
            this.$notify({ type: 'danger', message: 'Cannot cancel the auction' })
          }).then(() => {
            this.$store.commit('setLoadingSpinner', false)
          })
        }
      }

    }
  }
</script>

<style lang="scss" scoped>
  @import '../pfx.scss';

  h2 {
    font-family: 'Encode Sans', sans-serif;
    font-size: 24px;
    font-weight: 300;
    margin: 0;
  }

  h3 {
    font-size: 12px;
    font-weight: 600;
    color: #777;
    text-transform: uppercase;
    margin: 1em 0 0;
    line-height: 6px;
  }

  .draft-pill,
  .pending-pill,
  .approved-pill,
  .disqualified-pill,
  .abandoned-pill,
  .winner-pill,
  .bidders-pill {
    background-color: #e9e9e9;
    border-radius: 20px;
    display: inline-block;
    padding: 2px 12px;
    margin: 3px 0;
    a {
      //text-decoration: none;
      //color: inherit;
    }
  }
  .approved-pill { background-color: #bae5fa; }
  .winner-pill { background-color: $color-gold; background-image: $gradient-gold; font-weight: 600; }
  .bidders-pill { background-color: #D6EFB5; }

  .bold-link {
    font-weight: 600;
  }

  .alias {
    color: #777;
  }

  .actions {
    a {
      text-decoration: none;
    }
    a:hover {
      i {
        color: black !important;
      }
    }
  }

  .no-content-container {
    background-color: #fcfcfc;
    text-align: center;
    padding: 3rem;
  }
  .no-content-text {
    font-family: 'Encode Sans', sans-serif;
    font-size: 18px;
    font-weight: 300;
  }

  .col-12 { @include column(1/2); }
  .col-13 { @include column(1/3); }
  .col-14 { @include column(1/4); }

</style>



// WEBPACK FOOTER //
// src/components/DashboardPage.vue